// React
import React, { Fragment, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import Item from './Item'
import BBundleItems, { HostStyles } from './styles'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import { fetchPrice } from 'shop-components/redux/actions/price'
import { fetchAvailability } from 'shop-components/redux/actions/availability'

const BundleItems = ({ productId, items, cart, bundle, fetchPrice, fetchAvailability }) => {
  useEffect(() => {
    if (cart.id && bundle?.id) {
      fetchPrice({
        cartId: cart.id,
        id: bundle.id,
        configuration: bundle.configuration
      })
    }

    if (cart.startsAt && cart.stopsAt && cart.startLocationId) {
      fetchAvailability({
        startsAt: cart.startsAt,
        stopsAt: cart.stopsAt,
        startLocationId: cart.startLocationId,
        id: productId,
        configuration: bundle?.configuration
      })
    }
  }, [cart.id, cart.startsAt, cart.stopsAt, bundle?.configuration])

  const renderBundleItem = useCallback(
    (item) => <Item key={item.id} productId={productId} bundleItem={item} />,
    [productId]
  )

  return (
    <Fragment>
      <HostStyles />
      {items?.length && (
        <BBundleItems>
          <BBundleItems.Inner>
            {items.map(renderBundleItem)}
          </BBundleItems.Inner>
        </BBundleItems>
      )}
    </Fragment>
  )
}

BundleItems.propTypes = {
  productId: PropTypes.string.isRequired,
  cart: PropTypes.object,
  bundle: PropTypes.object,
  items: PropTypes.array,
  fetchPrice: PropTypes.func,
  fetchAvailability: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId || window.booqableOptions.cart?.id)
  const bundle = state.items.records[props.productId]

  return {
    cart: {
      id: cart?.id ?? window.booqableOptions.cart?.id,
      startsAt: cart?.starts_at ?? window.booqableOptions.cart?.from,
      stopsAt: cart?.stops_at ?? window.booqableOptions.cart?.till,
      startLocationId: cart?.start_location_id ?? window.booqableOptions?.startLocationId
    },
    bundle,
    items: bundle?.products
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchPrice: (attributes) => dispatch(fetchPrice(attributes)),
  fetchAvailability: (attributes) => dispatch(fetchAvailability(attributes))
})

const decoratedComponent = compose(withStore, withTheme, reduxConnect(mapStateToProps, mapDispatchToProps))(BundleItems)

registerCustomElement('bq-bundle-items', decoratedComponent, {
  attributes: ['product-id']
})

export default decoratedComponent
